/**
 * Utility functions for formatting educational boards/curriculums.
 */

/**
 * Formats a board object or label for dropdown and selection displays.
 * e.g., "KBPE (Kerala Board)", "CBSE (Central Board of Secondary Education)"
 * If code and name are identical (or only one is present), returns just the available string.
 *
 * @param {Object|string} board - Board object containing board_code/board_name or string
 * @returns {string} Formatted board label
 */
export const formatBoardLabel = (board) => {
  if (!board) return '';
  if (typeof board === 'string') return board;

  const code = (board.board_code || board.code || '').trim();
  const name = (board.board_name || board.name || '').trim();

  if (code && name) {
    if (code.toLowerCase() === name.toLowerCase()) {
      return code;
    }
    return `${code} (${name})`;
  }

  return code || name || board.label || '';
};
